import {z}from'zod';import {CrudSortOperator}from'../types/sortby.js';const e=z.record(z.nativeEnum(CrudSortOperator));export{e as CrudSortSchema};